import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const DistributionInformationSubForm = loadable(() =>
  withDefaultLoaderModifiers(import("./DistributionInformationSubForm"))
);
